module.exports = __webpack_public_path__ + "img/荜茇.6b9f94b9.jpg";